import {CANCEL_AJAX_REQUEST} from '../../constants';

export type CancelRequestAction = {
    /**
     * The action type
     */
    type : typeof CANCEL_AJAX_REQUEST;

    /**
     * The uid of the component the requests belongs to
     */
    componentUid : string;

    /**
     * The uid of the request itself
     */
    requestUid? : string
}

/**
 * @memberOf! Actions
 *
 * @param {String} componentUid         The uid of the component the requests belongs to
 * @param {String} requestUid           The uid of the request itself
 *
 * @return {CancelRequestAction}
 */
const cancelRequest = ( componentUid : string, requestUid? : string ) : CancelRequestAction => {
    return {
        type: CANCEL_AJAX_REQUEST,
        componentUid,
        requestUid
    };
}
export type CancelRequest = typeof cancelRequest;

export default cancelRequest;
